<template lang="pug">
  managementPage.scrollable(:title="$t(`${baseTranslationPath}.title`)"
                    @fetchData="loadList"
                    @openEditor="openEditor"
                    :searchPageSize="searchPageSize",
                    :showTotals="true"
                    :activeCampaignFilter="true"
                    :campaignFilterOptions="campaignFilterOptions"
                    :pagination="pagination"
                    :creatable="canView('/settings/campaigns/new')"
                    ref="managementPage")
      router-view(v-slot:editor)
      template(v-slot:body)
        aiq-table.main-contents(:data="items" v-loading="loading")
          aiq-table-column(:label="$t(`${baseTranslationPath}.name`)",
          :sort-method="onSortTitle"
          :sortable="true"
           min-width="40", label-class-name="is-bordered")
            template(v-slot:default="scope")
              span {{ scope.row.name }}
          aiq-table-column(:label="$t(`${baseTranslationPath}.description`)",
            :sort-method="onSortDescription"
            :sortable="true"
            min-width="60", label-class-name="is-bordered")
            template(v-slot:default="scope")
              span {{ scope.row.description }}
          aiq-table-column(:label="$t(`${baseTranslationPath}.status`)", min-width="40", label-class-name="is-bordered")
            template(v-slot:default="scope")
              span {{ scope.row.is_active ? 'Active' : 'Inactive' }}
          aiq-table-column(width="40", label-class-name="is-bordered" min-width="40")
            template(v-slot:default="scope")
              aiq-button(link type="primary" size="small", @click="openEditor(scope.row, 'view')") View
          aiq-table-column(v-if="canView('/settings/campaigns/:number')" min-width="40", label-class-name="is-bordered")
            template(v-slot:default="scope")
              aiq-button(link type="primary" size="small", @click="openEditor(scope.row)") Edit
</template>

<script>
import get from 'lodash/get';
import { mapState } from 'vuex';
import ManagementPage from '@/components/ManagementPage/ManagementPage.vue';
import { PAGINATION_DEFAULT } from '@/constants/pagination';
const SEARCH_PAGE_SIZE = 50;

export default {
  name: 'CampaignAdd',
  data() {
    return {
      pagination: PAGINATION_DEFAULT,
      loading: true,
      searchPageSize: SEARCH_PAGE_SIZE,
      getActive: true,
      baseTranslationPath: 'settings_tab.campaign_tab.manage',
      campaignFilterOptions: [
        {
          value: true,
          label: 'Active',
        },
        {
          value: false,
          label: 'Inactive',
        },
      ],
    };
  },
  components: {
    ManagementPage,
  },
  computed: {
    ...mapState({
      items: (state) => {
        return state.campaign.campaigns;
      },
    }),
  },
  methods: {
    async loadList({searchTerm, searchOffset, active}) {
      const params = {
        limit: this.searchPageSize,
        query: searchTerm,
        offset: searchOffset,
        active: active,
      };

      const response = await this.$store.dispatch(
        'campaign/getCampaignList',
        [params, searchOffset === 0],
      );
      this.loading = false;
      this.pagination = get(response, 'data.pagination', PAGINATION_DEFAULT);
      return response;
    },
    openEditor(record = {}, action = 'edit') {
      const id = get(record, 'id', 'new');
      const path = `${this.$route.path}/${id}`;
      if (action === 'view') {
        this.$router.push({
          path,
          query: {
            view: true,
          },
        });
      } else {
        this.$router.push({
          path,
        });
      }
    },
    onSortTitle(a, b) {
      const aValue = a.name.toLowerCase().replace(/\s+/g, '');
      const bValue = b.name.toLowerCase().replace(/\s+/g, '');
      return aValue < bValue ? 1 : -1;
    },
    onSortDescription(a, b) {
      const aValue = a.description.toLowerCase().replace(/\s+/g, '');
      const bValue = b.description.toLowerCase().replace(/\s+/g, '');
      return aValue < bValue ? 1 : -1;
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(tr) {
  height: 50px !important;
}
</style>